import { z } from 'zod';

/**
 * Scheme for ProvidersLiveDataConfigItem.
 */
const ProvidersLiveDataConfigItemScheme = z
  .object({
    providersServiceIds: z
      .union([z.array(z.string()), z.array(z.number())])
      .default([]),
    providerPredefinedGames: z
      .union([z.array(z.string()), z.array(z.number())])
      .default([]),
    intervalSeconds: z.number().default(60)
  })
  .passthrough()
  .default({});

/**
 * Scheme for ProviderAdditionalParams.
 */
const ProviderAdditionalParamsScheme = z
  .object({
    isPragmaticInstantLiveData: z.boolean().default(false)
  })
  .passthrough()
  .default({});

/**
 * Scheme for ProviderIdToAdditionalParamsMap.
 */
const ProviderIdToAdditionalParamsMapScheme = z
  .record(ProviderAdditionalParamsScheme)
  .default({});

/**
 * Scheme for ProvidersLiveDataConfig.
 */
export const ProvidersLiveDataConfigScheme = z
  .object({
    casino: ProvidersLiveDataConfigItemScheme,
    casinoLive: ProvidersLiveDataConfigItemScheme,
    instantGames: ProvidersLiveDataConfigItemScheme,
    defaultCurrency: z.string().default(''),
    providerIdToAdditionalParamsMap: ProviderIdToAdditionalParamsMapScheme
  })
  .passthrough()
  .default({});

export type ProvidersLiveDataConfig = z.infer<
  typeof ProvidersLiveDataConfigScheme
>;

export type ProviderIdToAdditionalParamsMap = z.infer<
  typeof ProviderIdToAdditionalParamsMapScheme
>;
